import { Spin, type SpinProps } from 'antd'
import clsx from 'clsx'

import './styles.scss'

interface HidingSpinProps extends SpinProps {
  className?: string
}

export function HidingSpin({
  className,
  spinning,
  children,
  ...props
}: HidingSpinProps) {
  return (
    <Spin
      className={clsx('hiding-spin', className)}
      spinning={spinning}
      {...props}
    >
      <div
        className={clsx('hiding-spin__content', {
          'hiding-spin__content--hidden': spinning,
        })}
      >
        {children}
      </div>
    </Spin>
  )
}
